// BRANCH STATUSES
import {
    COLOR_SUCCESS_ACTIVE,
    COLOR_WARNING_ACTIVE,
    COLOR_WARNING_STRONG_ACTIVE,
    STATUS_ERROR,
    STATUS_SUCCESS,
    STATUS_WARNING
} from "./Colors";

export const BRANCH_RELOAD_PERIOD_IN_MILLISECONDS=180_000
export const BRANCH_STATUS_DEFAULT = 0

export const BRANCH_STATUS_MOVE_TO_NEAREST_WITH_PICK_UP = 1
export const BRANCH_STATUS_MOVE_TO_NEAREST_WITHOUT_PICK_UP = 2
export const BRANCH_STATUS_ONLY_DELIVERY = 3
export const BRANCH_STATUS_ONLY_PICK_UP = 4
export const BRANCH_STATUS_CLOSED = 5


export const getBranchStatusText = (mode: number) => {
    switch (mode) {
        case BRANCH_STATUS_DEFAULT:
            return "Работает в обычном режиме"
        case BRANCH_STATUS_MOVE_TO_NEAREST_WITH_PICK_UP:
            return "Ближайший филиал с самовывоза"
        case BRANCH_STATUS_MOVE_TO_NEAREST_WITHOUT_PICK_UP:
            return "Ближайший филиал без самовывоза"
        case BRANCH_STATUS_ONLY_DELIVERY:
            return "Только доставка"
        case BRANCH_STATUS_ONLY_PICK_UP:
            return "Только самовывоз"
        default:
            return "Закрыт"
    }
}

export const getBranchDeliveryColor = (mode: number | undefined) => {
    switch (mode) {
        case BRANCH_STATUS_DEFAULT:
        case BRANCH_STATUS_ONLY_DELIVERY:
            return COLOR_SUCCESS_ACTIVE
        case BRANCH_STATUS_MOVE_TO_NEAREST_WITHOUT_PICK_UP:
        case BRANCH_STATUS_MOVE_TO_NEAREST_WITH_PICK_UP:
            return COLOR_WARNING_ACTIVE
        default:
            return COLOR_WARNING_STRONG_ACTIVE
    }
}

export const getBranchPickUpColor = (mode: number | undefined) => {
    switch (mode) {
        case BRANCH_STATUS_DEFAULT:
        case BRANCH_STATUS_ONLY_PICK_UP:
        case BRANCH_STATUS_MOVE_TO_NEAREST_WITH_PICK_UP:
            return COLOR_SUCCESS_ACTIVE
        default:
            return COLOR_WARNING_STRONG_ACTIVE
    }
}


export const getBranchStatus = (mode: number) =>
    (mode === BRANCH_STATUS_DEFAULT || mode === BRANCH_STATUS_ONLY_DELIVERY)
        ? STATUS_SUCCESS
        : (mode === BRANCH_STATUS_MOVE_TO_NEAREST_WITH_PICK_UP || mode === BRANCH_STATUS_MOVE_TO_NEAREST_WITHOUT_PICK_UP)
            ? STATUS_WARNING : STATUS_ERROR

export const BELLISSIMO = "Bellissimo"
export const getBranchShortName = (name: string | null) => name?.includes(BELLISSIMO) ? name?.substring(BELLISSIMO.length) : name